var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('b-jumbotron',{staticClass:"w-50 mx-auto mt-2"},[_c('h1',[_vm._v("Welkom!")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }